import { PaginationProps as TablePaginationConfig } from "antd/lib/pagination";

import {
	SalesActivityReminderUnit,
	TriggerActionEntityTypes
} from "./Others/SalesActivity";
import { cacheConstant } from "./appCache";
import { UserCompany } from "./Users";
import { CustomField } from "./Settings";

export enum ZomentumRoutes {
	AccountSettings = "/settings/account",
	Assessments = "/assessments",
	Authorize = "/authorize",
	AutoTaskIntegration = "/settings/integrations/autotask-integration",
	CancelSubscription = "/settings/cancel",
	ClientsDetail = "/clients/:id",
	ClientsList = "/clients",
	ContactsList = "/contacts",
	ConnectWiseIntegration = "/settings/integrations/connectwise-integration",
	CreateReport = "/create-report",
	CustomFieldsList = "/settings/custom-fields/:entity",
	CustomFieldsSettings = "/settings/custom-fields",
	DocumentsDetail = "/documents/:id",
	DocumentsList = "/documents",
	DocumentsPdfView = "/documents/view/pdf/:id",
	DocumentsPreview = "/documents/view/:id",
	DocumentSuccessSignature = "/success/signature",
	EmailSettings = "/settings/email-settings",
	EmailTemplateSettings = "/settings/email-templates",
	Error = "/error",
	NotFound = "/not-found",
	IntegrationSettings = "/settings/integrations",
	AirtableIntegration = "/settings/integrations/airtable-integration",
	InfusionSoftIntegration = "/settings/integrations/infusionsoft-integration",
	HubSpotIntegration = "/settings/integrations/hubspot-integration",
	InvoicesList = "/settings/invoices",
	KaseyaIntegration = "/settings/integrations/kaseya-integration",
	LoginOrSignup = "/welcome",
	Login = "/login",
	Ms365AssessmentSuccess = "/assessments/ms365/success",
	Notifications = "/settings/notifications",
	OpportunityDetail = "/opportunities/:id",
	OpportunityList = "/opportunities",
	PipelineSettings = "/settings/pipeline",
	Preferences = "/settings/preferences",
	ProductsDetail = "/products/:id",
	ProductsList = "/products",
	RepairShoprIntegrationPage = "/settings/integrations/repairshopr-integration",
	ReportsDetail = "/reports/:id",
	ReportsList = "/reports",
	SalesActivityAutomationCreate = "/sales-automation/create",
	SalesActivityAutomationsEdit = "/sales-automation/edit/:id",
	SalesActivityAutomationsClone = "/sales-automation/clone/:id",
	SalesActivityAutomationsList = "/sales-automation",
	Settings = "/settings",
	SignatureSuccessIframe = "/signature-callback",
	SyncroIntegration = "/settings/integrations/syncro-integration",
	Suppliers = "/settings/suppliers",
	TaxRegionSettings = "/settings/tax-regions",
	TemplatesDetail = "/templates/:id",
	TemplatesList = "/templates",
	TimezoneSettings = "/settings/account/:feature",
	Unauthorized = "/unauthorized",
	UserSettings = "/settings/users",
	VerifyEmail = "/verify-email",
	SetupAccount = "/setup-account",
	VerifyPayment = "/payment/:id",
	SalesActivityPage = "/sales-activity",
	OnBoardingScheduledPage = "/onboarding",
	AuditLogs = "/audit-logs",
	DocumentApproval = "/settings/document-approval",
	DocumentApprovalDetailsPage = "/settings/document-approval/:id",
	DocumentApprovalCreatePage = "/settings/document-approval/create",
	BulkActionResultPage = "/async/:id",
	Billing = "/settings/billing",
	PurchaseOrder = "/purchaseorders",
	PurchaseOrderAddPage = "/purchaseorders/add",
	PurchaseOrderSubmitPage = "/purchaseorder/submit/:id",
	PurchaseOrderDetailPage = "/purchaseorder/:id",
	PricingPlanErrorPage = "/pricingplanerror",
	DocumentApprovalPricingPlanErrorPage = "/documentapproval-pricingplanerror",
	Marketplace = "/align",
	MarketplaceCollection = "/align/collections/:collectionRoute",
	MarketplaceResourcePage = "/align/vendors/:id/resources",
	MarketplaceResourcePageDirectory = "/align/vendors/:id/resources/:directoryId",
	MarketplaceProductDetail = "/align/products/:id",
	MarketplaceSettingsPage = "/settings/align",
	MarketplaceMyVendors = "/align/vendors",
	MarketplaceVendorDetail = "/align/vendors/:id",
	QuickbooksIntegration = "/settings/integrations/quickbooks-integration",
	ZapierIntegrationPage = "/settings/integrations/zapier",
	GoogleDriveIntegrationPage = "/settings/integrations/google-cloud",
	MarketplaceSubscriptions = "/align/subscriptions",
	MarketplaceMyVendorsOld = "/marketplace/my-vendors",
	HaloPSAIntegrationPage = "/settings/integrations/halopsa-integration",
	MarketplaceCommissions = "/align/commissions",
	PartnerDashboard = "/partner/dashboard",
	// Vendor Routes
	VendorPartnersDetail = "/partners/:id",
	VendorOpportunityList = "/opportunities",
	VendorPartnerList = "/partners",
	VendorSettings = "/settings",
	VendorResources = "/resources",
	VendorResourcesFolder = "/resources/:id",
	VendorDashboard = "/dashboard",
	VendorMarketplace = "/align",
	VendorCompanyDetails = "/settings/company-details",
	VendorCustomFieldsList = "/settings/custom-fields/:entity",
	VendorCustomFieldsSettings = "/settings/custom-fields",
	VendorMarketplaceListings = "/listings",
	VendorMarketplaceProductListings = "/settings/listings",
	VendorMarketplaceAddProduct = "/settings/listings/add",
	VendorMarketplaceEditProduct = "/settings/listings/:id",
	VendorMarketplaceSKUs = "/products",
	VendorOpportunityDetail = "/opportunities/:id",
	VendorTemplates = "/templates",
	VendorTemplateDetail = "/templates/:id",
	VendorMarketplaceSKUDetails = "/products/:id",
	VendorAccountSettings = "/settings/account",
	VendorPipelineSettings = "/settings/pipeline",
	VendorUsers = "/settings/users",
	VendorPartnerSettings = "/settings/partner",
	VendorPartnersBulkImport = "/import/partners",
	VendorClientBulkImport = "/import/vendor_client",
	VendorOpportunitiesBulkImport = "/import/opportunity",
	VendorProductsBulkImport = "/import/products",
	VendorClientList = "/clients",
	VendorClientDetail = "/clients/:id",
	VendorEmailTemplateSettings = "/settings/email-templates",
	CustomDistributorIntegrationAdd = "/settings/integrations/custom-distributor/add",
	CustomDistributorIntegrationDetail = "/settings/integrations/custom-distributor/:id",
	VendorPartnerTiering = "/settings/tiering",
	UnsubscribeEmails = "/unsubscribe-emails",
	FinancePage = "/finance",
	SentryAutoFixTest = "/sentry-auto-fix-test"
}

export interface ZomentumWindow extends Window {
	__REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
	dataLayer: Array<any>;
	_LTracker: any;
	HubSpotConversations: any;
	hsConversationsSettings: any;
	hsConversationsOnReady: any;
	fcWidget: any;
	FreshworksWidget: any;
	fwSettings: any;
	tinyMCE: any;
	Chargebee: any;
	hj: any;
	_hjSettings: any;
	isDevelopment: boolean;
	isStaging: boolean;
	isLocalhost: boolean;
	REACT_APP_SHA: any;
	FS: any;
	parent: ZomentumWindow;
	iframeCallbackEmitter: any;
	Beamer: any;
	CollectJS: any;
	ChiliPiper: any;
	Calendly: any;
	CKEDITOR: any;
}

export class HttpErrorResponse {
	code = 0;
	description = "";
	errors: any = {};
	should_display_description_string = false;
	subtype = "";
}

export const PasswordRegex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

export const EmailRegex =
	/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const SubdomainRegex = /^[a-zA-Z0-9][a-zA-Z0-9.-]+[a-zA-Z0-9]$/;

export const companyFormSubdomainRegex =
	/^[A-Za-z0-9](?:[A-Za-z0-9\-]{0,61}[A-Za-z0-9])$/;

export const PhoneRegex = /^[\d()+-]{0,20}$/;

export const AlphabetsOnlyRegex = /^[a-zA-Z]+$/;

export const AlphaNumericWithDashesRegex = /^[A-Za-z0-9_-]*$/;

export const DefaultTimestampFormat = "MMM D, YYYY";

export const DefaultTimestampFormatWithTime = "MMM D, YYYY hh:mm:ss A";

export const FullDateFormat = "MMMM Do YYYY";

export const TimeFormat = "hh:mm A";

export const URLRegex =
	/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[-a-zA-Z]{2,10}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

// NOTE ON CREDIT CARD REGEX
// ^(?:4[0-9]{12}(?:[0-9]{3})?          # Visa
//  |  (?:5[1-5][0-9]{2}                # MasterCard
//      | 222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}
//  |  3[47][0-9]{13}                   # American Express
//  |  3(?:0[0-5]|[68][0-9])[0-9]{11}   # Diners Club
//  |  6(?:011|5[0-9]{2})[0-9]{12}      # Discover
//  |  (?:2131|1800|35\d{3})\d{11}      # JCB
// )$
export const CreditCardRegex =
	"^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}| 222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35d{3})d{11})$";

export enum Currency {
	DKK = "DKK",
	USD = "USD",
	SEK = "SEK",
	CAD = "CAD",
	AUD = "AUD",
	NZD = "NZD",
	EUR = "EUR",
	GBP = "GBP",
	INR = "INR",
	ZAR = "ZAR",
	ALL = "ALL",
	AMD = "AMD",
	AZN = "AZN",
	BYN = "BYN",
	BAM = "BAM",
	BGN = "BGN",
	HRK = "HRK",
	CZK = "CZK",
	GEL = "GEL",
	HUF = "HUF",
	ISK = "ISK",
	MDL = "MDL",
	NOK = "NOK",
	PLN = "PLN",
	RON = "RON",
	RUB = "RUB",
	MKD = "MKD",
	RSD = "RSD",
	CHF = "CHF",
	TRY = "TRY",
	UAH = "UAH",
	SGD = "SGD",
	HKD = "HKD",
	AED = "AED",
	BRL = "BRL",
	BHD = "BHD",
	FJD = "FJD",
	NIS = "NIS"
}

export interface CurrencyOpt {
	symbol: Currency;
	label: string;
}
export const CurrencyOptions: CurrencyOpt[] = [
	{ symbol: Currency.USD, label: "US Dollar (USD)" },
	{ symbol: Currency.DKK, label: "Danish Krone (DKK)" },
	{ symbol: Currency.SEK, label: "Swedish Krona (SEK)" },
	{ symbol: Currency.CAD, label: "Canadian Dollar (CAD)" },
	{ symbol: Currency.AUD, label: "Australian Dollar (AUD)" },
	{ symbol: Currency.NZD, label: "New Zealand Dollar (NZD)" },
	{ symbol: Currency.EUR, label: "Euro (EUR)" },
	{ symbol: Currency.GBP, label: "Pound Sterling (GBP)" },
	{ symbol: Currency.INR, label: "Indian Rupee (INR)" },
	{ symbol: Currency.ZAR, label: "Rand (ZAR)" },
	{ symbol: Currency.ALL, label: "Albanian LEK (ALL)" },
	{ symbol: Currency.AMD, label: "Armenian Dram (AMD)" },
	{ symbol: Currency.AZN, label: "Azerbaijani manat (AZN)" },
	{ symbol: Currency.BYN, label: "Belarusian ruble (BYN)" },
	{
		symbol: Currency.BAM,
		label: "Bosnia and Herzegovina convertible mark (BAM)"
	},
	{ symbol: Currency.BGN, label: "Bulgarian lev (BGN)" },
	{ symbol: Currency.HRK, label: "Croatian kuna (HRK)" },
	{ symbol: Currency.CZK, label: "Czech koruna (CZK)" },
	{ symbol: Currency.GEL, label: "Georgian lari (GEL, ₾)" },
	{ symbol: Currency.HUF, label: "Hungarian forint (HUF, Ft)" },
	{
		symbol: Currency.ISK,
		label: "Icelandic króna: second króna (ISK, kr, Íkr)"
	},
	{ symbol: Currency.MDL, label: "Moldovan leu (MDL, L)" },
	{ symbol: Currency.NOK, label: "Norwegian krone (NOK, kr, –)" },
	{ symbol: Currency.PLN, label: "Polish złoty (PLN, zł)" },
	{ symbol: Currency.RON, label: "Romanian leu (RON, lei)" },
	{ symbol: Currency.RUB, label: "Russian ruble (RUB, ₽)" },
	{ symbol: Currency.MKD, label: "Second Macedonian denar (MKD, ден)" },
	{
		symbol: Currency.RSD,
		label: "Serbian dinar (RSD, RSD or РСД (unofficial: din. or дин.))"
	},
	{ symbol: Currency.CHF, label: "Swiss franc (CHF, CHF)" },
	{ symbol: Currency.TRY, label: "Turkish lira (TRY, ₺)" },
	{ symbol: Currency.UAH, label: "Ukrainian hryvnia (UAH, ₴)" },
	{ symbol: Currency.SGD, label: "Singapore Dollar (SGD)" },
	{ symbol: Currency.HKD, label: "Hong kong Dollar (HKD)" },
	{ symbol: Currency.AED, label: "United Arab Emirates Dirham (AED)" },
	{ symbol: Currency.BRL, label: "Brazilian Real (BRL, R$)" },
	{ symbol: Currency.BHD, label: "Bahraini Dinars (BHD)" },
	{ symbol: Currency.FJD, label: "Fijian Dollar (FJD)" },
	{ symbol: Currency.NIS, label: "New Israeli Shekel (NIS)" }
];

export interface CurrencyView {
	code: string;
	displayName: string;
}

export interface CurrencyConfigUpdatedByView {
	id: string;
	email?: string | null;
	name: {
		first?: string | null;
		last?: string | null;
		full?: string | null;
	};
}

export interface CurrencyConfigView {
	currency: CurrencyView;
	exchangeRate: number;
	updatedAt: string;
	updatedBy?: CurrencyConfigUpdatedByView | null;
}

export interface CurrencyConfigurationView {
	primaryCurrency: CurrencyView;
	currencyConfigs: CurrencyConfigView[];
}

export interface DocumentCurrencyConfigView {
	currency: CurrencyView;
	frozenExchangeRate?: number;
	frozenAt?: string;
}

export interface AddCurrencyRequest {
	currency: string;
	exchangeRate: number;
}

export interface UpdateExchangeRateRequest {
	exchangeRate: number;
}

export const DefaultErrorMessage = "Something went wrong";

export const DefaultPaginationPageSize = 50;

export class Name {
	first = "";
	full = "";
	last = "";

	public static getInitials = (name: Name): string =>
		(name.full || name.first)
			.split(" ")
			.filter(a => !!a && !!a.length)
			.map(a => a[0].toUpperCase())
			.join(" ");
}

export class Address {
	id: string | null = null;
	address_line_1 = "";
	address_line_2 = "";
	city = "";
	country = "";
	phone = "";
	pincode = "";
	state = "";
	is_default = false;
	sync_data?: SyncData[];
	custom_fields?: CustomField[];

	constructor(
		address_line_1 = "",
		address_line_2 = "",
		city = "",
		state = "",
		pincode = "",
		country = "",
		phone = "",
		is_default = false
	) {
		this.address_line_1 = address_line_1;
		this.address_line_2 = address_line_2;
		this.city = city;
		this.country = country;
		this.phone = phone;
		this.pincode = pincode;
		this.state = state;
		this.is_default = is_default;
	}
}

export class PurchaseOrderAddress {
	id: string | null = null;
	address_line_1: string | null = null;
	address_line_2: string | null = null;
	city: string | null = null;
	country: string | null = null;
	phone: string | null = null;
	pincode: string | null = null;
	state: string | null = null;
	is_default = false;
	sync_data?: SyncData[];
}

export class Social {
	facebook = "";
	linkedin = "";
	reddit = "";
	twitter = "";
	website = "";
}

export class LinkHref {
	href = "";
}

export class Links {
	next: LinkHref = new LinkHref();
	self: LinkHref = new LinkHref();
}

export class DeletedRecord {
	deleted = false;
}

export class NotificationConfiguration {
	api_key = "";
	app_id = "";
	token = "";
}

export class NotificationSetting {
	reminder_unit: SalesActivityReminderUnit | null = null;
	is_enabled = false;
	reminder_interval = 0;
}

export class NotificationSettings {
	sales_meeting_email_reminder: NotificationSetting =
		new NotificationSetting();
	sales_meeting_in_app_reminder: NotificationSetting =
		new NotificationSetting();
	sales_task_email_reminder: NotificationSetting = new NotificationSetting();
	sales_task_in_app_reminder: NotificationSetting = new NotificationSetting();
	digest_daily_email_notification = false;
	digest_weekly_email_notification = false;
	document_comment_email_notification = false;
	document_view_email_notification = false;
	document_signature_cancel_email_notification = false;
	document_in_draft_email_notification = false;
	document_sent_but_not_viewed_email_notification = false;
	document_viewed_but_not_approved_email_notification = false;
	tier_change_in_app_notification = false;
	resource_shared_in_app_notification = false;
}

export enum ZomentumEntities {
	Address = "address",
	Client = "client_company",
	Products = "items",
	Document = "document",
	DocumentBlock = "block",
	Comment = "comment",
	Activities = "activities",
	Opportunity = "opportunity",
	Product = "item",
	ClientContact = "client_user",
	SalesTask = "task",
	SalesMeeting = "meeting",
	Email = "email",
	EmailThread = "thread",
	EmailMessage = "message",
	SalesLogEmail = "log_email",
	SalesLogCall = "log_call",
	Assessment = "assessment",
	Qbr = "qbr",
	CustomField = "custom_field",
	SalesActivity = "sales_activity",
	Supplier = "supplier",
	User = "user",
	Pricing = "pricing",
	VendorResource = "vendor_resource",
	VendorPartner = "partner_metadata",
	VendorCompany = "company",
	MarketplaceListing = "marketplace_listing",
	Vendors = "vendors",
	VendorCompanies = "vendor_company",
	VendorTemplate = "template",
	VendorOpportunity = "vendor_opportunity",
	MarketplaceSKU = "marketplace_sku",
	VendorClient = "vendor_client_company",
	VendorClientContact = "vendor_client_user",
	SalesAutomation = "sales_automation_rule",
	VendorUser = "vendor_user",
	Transaction = "transaction",
	RecurringCommissionRecords = "commission_record",
	Invoice = "partner_align_invoice",
	CommissionRule = "commission_automation_rule"
}

export const getZomentumEntityDisplayValue = (
	zomentumEntity: TriggerActionEntityTypes | undefined | null,
	isSingular: boolean
): string => {
	if (!zomentumEntity || zomentumEntity.length === 0) {
		return "";
	}
	switch (zomentumEntity) {
		case ZomentumEntities.Address: {
			return "Client Shipping Address";
		}
		case ZomentumEntities.Client: {
			return isSingular ? "Client" : "Clients";
		}
		case ZomentumEntities.Products: {
			return isSingular ? "Product" : "Products";
		}
		case ZomentumEntities.Document: {
			return isSingular ? "Document" : "Documents";
		}
		case ZomentumEntities.DocumentBlock: {
			return isSingular ? "Block" : "Blocks";
		}
		case ZomentumEntities.Comment: {
			return isSingular ? "Note" : "Notes";
		}
		case ZomentumEntities.Activities: {
			return isSingular ? "Activity" : "Activities";
		}
		case ZomentumEntities.Opportunity: {
			return isSingular ? "Opportunity" : "Opportunities";
		}
		case ZomentumEntities.Product: {
			return isSingular ? "Product" : "Products";
		}
		case ZomentumEntities.ClientContact: {
			return isSingular ? "Contact" : "Contacts";
		}
		case ZomentumEntities.SalesTask: {
			return isSingular ? "Task" : "Tasks";
		}
		case ZomentumEntities.SalesMeeting: {
			return isSingular ? "Meeting" : "Meetings";
		}
		case ZomentumEntities.Email: {
			return isSingular ? "Email" : "Emails";
		}
		case ZomentumEntities.EmailThread: {
			return isSingular ? "Thread" : "Threads";
		}
		case ZomentumEntities.EmailMessage: {
			return isSingular ? "Email" : "Emails";
		}
		case ZomentumEntities.SalesLogEmail: {
			return isSingular ? "Email Log" : "Email Logs";
		}
		case ZomentumEntities.SalesLogCall: {
			return isSingular ? "Call Log" : "Call Logs";
		}
		case ZomentumEntities.Assessment: {
			return isSingular ? "Assessment" : "Assessments";
		}
		case ZomentumEntities.Pricing: {
			return isSingular ? "Pricing" : "Pricings";
		}
		case ZomentumEntities.VendorPartner: {
			return isSingular ? "Partner" : "Partners";
		}
		case ZomentumEntities.VendorClient: {
			return isSingular ? "Client" : "Clients";
		}
		case ZomentumEntities.VendorOpportunity: {
			return isSingular ? "Opportunity" : "Opportunities";
		}
		case ZomentumEntities.VendorClientContact: {
			return isSingular ? "Contact" : "Contacts";
		}
		case ZomentumEntities.MarketplaceSKU: {
			return isSingular ? "Product" : "Products";
		}
		case ZomentumEntities.Transaction: {
			return isSingular ? "Transaction" : "Transactions";
		}
		default: {
			return (zomentumEntity as string)
				.split("_")
				.join(" ")
				.replace(/\b\w/g, (word: string) => word.toUpperCase());
		}
	}
};

export const getRouteFromEntity = (entity: ZomentumEntities): string => {
	switch (entity) {
		case ZomentumEntities.Client: {
			return ZomentumRoutes.ClientsDetail;
		}
		case ZomentumEntities.Document: {
			return ZomentumRoutes.DocumentsDetail;
		}
		case ZomentumEntities.Opportunity: {
			return ZomentumRoutes.OpportunityDetail;
		}
		case ZomentumEntities.Product: {
			return ZomentumRoutes.ProductsDetail;
		}
		default: {
			return "/";
		}
	}
};

export const ZomentumLoginRoutes: string[] = [
	ZomentumRoutes.LoginOrSignup,
	ZomentumRoutes.Login,
	ZomentumRoutes.VerifyEmail
];

export const getDefaultGrowPrivateRoute = (
	_showPartnerAlignFeaturesFlag?: boolean
) => ZomentumRoutes.OpportunityList;

export const DefaultPartnerAlignPrivateRoute = ZomentumRoutes.VendorDashboard;

export interface ZomentumRouteParams {
	id: string;
	entity: ZomentumEntities;
	feature: string;
}

export class ZomentumEntityRequest {
	entityType: ZomentumEntities;
	entityId: string;
	accountId?: string;
	constructor(
		entityType: ZomentumEntities,
		entityId: string,
		accountId?: string
	) {
		this.entityType = entityType;
		this.entityId = entityId;
		this.accountId = accountId;
	}
}

export const ZomentumStorageKeys = {
	Token: "token",
	UserIp: "userip",
	Currency: "currency",
	Locale: "locale",
	DocumentType: "document-type",
	LastUsedEmail: "last-used-email",
	PendingPurchaseOrderReminder: "pending-purchase-order-reminder",
	UserCompany: cacheConstant.userCompany,
	ShouldUpdateOppStageOnDocManualUpdate:
		"should-update-opp-stage-on-doc-manual-update",
	MARKETPLACE_MYVENDORS_VIEW: "MARKETPLACE_MYVENDORS_VIEW",
	MARKETPLACE_HOME_VIEW: "MARKETPLACE_HOME_VIEW",
	INSIGHTS_TIME_RANGE: "INSIGHTS_TIME_RANGE",
	VENDOR_PROMOTION_DISMISSED: "VENDOR_PROMOTION_DISMISSED",
	GOF_BLOCK_CACHE: "GOF_BLOCK_CACHE",
	HUBSPOT_CHAT_TOKEN_LIST: "HUBSPOT_CHAT_TOKEN_LIST",
	SUBSCRIPTIONS: "SUBSCRIPTIONS",
	RETURN_TO_URL: "return_to_url",
	DASHBOARD_REVENUE_DATE_RANGE: "DASHBOARD_REVENUE_DATE_RANGE",
	PARTNER_RESOURCE_INSIGHTS: "PARTNER_RESOURCE_INSIGHTS",
	PARTNER_REVENUE_INSIGHTS: "PARTNER_REVENUE_INSIGHTS",
	APP_STATE: "APP_STATE",
	DASHBOARD_RESOURCE_DATE_FILTER: "DASHBOARD_RESOURCE_DATE_FILTER",
	SUPEROPS_HINT: "SUPEROPS_HINT",
	SUPEROPS_REGION: "SUPEROPS_REGION",
	SUPEROPS_SSO_RETRIED: "SUPEROPS_SSO_RETRIED"
};

export enum TableQueryFilterOperands {
	EqualTo = "=",
	MongoDbEqualTo = ":eq:",
	MongoDbMatches = ":in:",
	MongoDbLessThan = ":lt:",
	MongoDbLessThanOrEqualTo = ":lte:",
	MongoDbGreaterThan = ":gt:",
	MongoDbGreaterThanOrEqualTo = ":gte:",
	MongoDbRange = ":range:",
	NotInArray = ":non_empty_array:",
	MongoDbNotEqualTo = ":ne:",
	MongoDbNotIn = ":nin:",
	MongoDbNotNull = ":nnull:",
	MongoDbNull = ":null:"
}

export enum TableTimestampFilterKeys {
	Last24Hours = "Last 24 Hours",
	Yesterday = "Yesterday",
	Next24Hours = "Next 24 Hours",
	Last7Days = "Last 7 Days",
	Next7Days = "Next 7 Days",
	Last30Days = "Last 30 Days",
	Next30Days = "Next 30 Days",
	AllTime = "All Time",
	Custom = "Custom",
	Today = "Today",
	ThisWeek = "This Week"
}

export type TableQueryFilterKeys =
	| "page"
	| "sort"
	| "limit"
	| "name"
	| "name.full"
	| "status"
	| "recipients.entity_id"
	| "type"
	| "opportunity_pipeline_stage_id"
	| "owner_user_id"
	| "opportunity_pipeline_id"
	| "created"
	| "synced_from"
	| "updated"
	| "date_time"
	| "estimated_close_date"
	| "author_id"
	| "owner_user_id"
	| "outcome"
	| "priority"
	| "client_company_id"
	| "partner_company_id"
	| "opportunity_id"
	| "document_type"
	| "external_editor.editor_type"
	| "external_editor.is_free_doc"
	| "included_feed_types"
	| "task_type"
	| "comment_attachments"
	| "vendor_client_company_id"
	| "tier_ids"
	| "partner_company_id"
	| "opportunity_vendor_details.vendor_company_id"
	| "id"
	| "inbox_type"
	| "is_single_block";

export enum ETableQueryFilterKeys {
	AUTHOR_ID = "author_id",
	OWNER_USER_ID = "owner_user_id",
	ESTIMATED_CLOSE_DATE = "estimated_close_date",
	DATE_TIME = "date_time",
	COMMENT_ATTACHMENTS = "comment_attachments",
	PRIORITY = "priority",
	OUTCOME = "outcome",
	INBOX_TYPE = "inbox_type"
}
export interface DefaultTableFilterSortSearchParameters {
	currentFilters: TableQueryFilter[];
	currentKeywords: string | null;
	currentPagination: TablePaginationConfig;
}

export const DefaultTableFilterSortSearch: DefaultTableFilterSortSearchParameters =
	{
		currentFilters: new Array<TableQueryFilter>(),
		currentKeywords: null,
		currentPagination: {
			pageSize: DefaultPaginationPageSize,
			defaultPageSize: DefaultPaginationPageSize,
			hideOnSinglePage: true
		}
	};

export class TableQueryFilter {
	operand: TableQueryFilterOperands;
	filterKey: TableQueryFilterKeys;
	filterValue: string | number | undefined;
	filterDisplayText: string | null;
	filterEnable: boolean;
	constructor(
		operand: TableQueryFilterOperands,
		filterKey: TableQueryFilterKeys,
		filterValue: string | number | undefined,
		filterDisplayText?: string | null,
		filterEnable = false
	) {
		this.operand = operand;
		this.filterKey = filterKey;
		this.filterValue = filterValue;
		this.filterDisplayText = filterDisplayText || null;
		this.filterEnable = filterEnable;
	}
}

export interface UppyFileMetaData {
	width?: number;
	height?: number;
	thumbnail?: string;
}

export interface SyncData {
	synced_from: ZomentumPSA;
	sync_source_id?: string;
	sync_source_url?: string;
	last_synced_at?: Date;
	is_origin?: boolean;
	is_deleted_from_sync_source?: boolean;
	synced_from_display_value?: string;
}

export abstract class ZomentumEntity {}

export abstract class ZomentumSyncEntity {
	sync_data?: SyncData[];
}

export abstract class ArchievedWithSyncModel extends ZomentumSyncEntity {
	archived?: boolean;
}

export enum ZomentumPageTitles {
	Zomentum = "Zomentum"
}

export interface FileUploadResponse {
	readonly upload_url: string;
}

export enum FileUploadStatus {
	DONE = "done",
	REMOVED = "removed",
	ERROR = "error"
}

export enum ZomentumPSA {
	ConnectWise = "connectwise",
	Autotask = "autotask",
	Kaseya = "kaseya",
	Syncro = "syncro",
	RepairShopr = "repairshopr",
	Quickbooks = "quickbooks_online",
	Hubspot = "hubspot",
	InfusionSoft = "infusion_soft",
	HaloPSA = "haloPSA",
	Etilize = "etilize",
	Icecat = "icecat",
	Amazon = "amazon_business",
	SuperOps = "superops"
}

export const zomentumPSALabel: Record<ZomentumPSA, string> = {
	[ZomentumPSA.ConnectWise]: "ConnectWise PSA",
	[ZomentumPSA.Autotask]: "Autotask",
	[ZomentumPSA.Kaseya]: "Kaseya BMS",
	[ZomentumPSA.Syncro]: "Syncro",
	[ZomentumPSA.RepairShopr]: "RepairShopr",
	[ZomentumPSA.Quickbooks]: "Quickbooks Online",
	[ZomentumPSA.Hubspot]: "HubSpot",
	[ZomentumPSA.InfusionSoft]: "InfusionSoft",
	[ZomentumPSA.HaloPSA]: "HaloPSA",
	[ZomentumPSA.Etilize]: "Etilize",
	[ZomentumPSA.Icecat]: "Icecat",
	[ZomentumPSA.Amazon]: "Amazon Business",
	[ZomentumPSA.SuperOps]: "SuperOps"
};

export const allowedPSAForCRMPushtoPSA = [
	ZomentumPSA.ConnectWise,
	ZomentumPSA.Kaseya,
	ZomentumPSA.Autotask
];

export const ZomentumPSAsArray = [
	ZomentumPSA.Autotask,
	ZomentumPSA.ConnectWise,
	ZomentumPSA.Kaseya,
	ZomentumPSA.Syncro,
	ZomentumPSA.HaloPSA,
	ZomentumPSA.RepairShopr,
	ZomentumPSA.Quickbooks,
	ZomentumPSA.Hubspot,
	ZomentumPSA.InfusionSoft
];

export enum CBSupportedCurrency {
	USD = "USD",
	CAD = "CAD"
}

export interface KeyValuePair {
	key: string;
	value: string;
}

export enum NumberLimit {
	NUMBER_MAX = 2147483647
}

export interface FormAlignment {
	labelCol: {
		span: number;
	};
	wrapperCol: {
		span: number;
	};
}
export enum CommonServerStatusEnum {
	Success = "success",
	Failure = "failure"
}

export enum ShippingAddressFormItems {
	AddressLine1 = "address_line_1",
	AddressLine2 = "address_line_2",
	City = "city",
	State = "state",
	Pincode = "pincode",
	Country = "country"
}

export enum AppName {
	Grow = "grow",
	PartnerAlign = "partner_align"
}

export enum ResourceFileType {
	Image = "image",
	Video = "video",
	File = "file",
	Spreadsheet = "spreadsheet",
	Document = "document",
	Folder = "folder",
	SVG = "svg",
	Youtube = "youtube",
	Pdf = "pdf",
	Txt = "txt",
	Presentation = "presentation",
	Csv = "csv"
}

export interface AddressValues {
	address_line_1?: string;
	address_line_2?: string;
	city?: string;
	country?: string;
	phone?: string;
	pincode?: string;
	state?: string;
	is_default?: boolean;
	sync_data?: SyncData[];
}

export enum OpportunityRevenueAndCostText {
	one_time = "One time revenue",
	weekly = "Weekly revenue",
	quarterly = "Quartly revenue",
	monthly = "Monthly revenue",
	semi_annually = "Semi-Annually revenue",
	annual = "Annually revenue",
	semi_annually_cost = "Semi-Annually cost",
	total_cost = "cost",
	total_revenue = "revenue"
}

export enum V2ZomentumRoutes {
	BILLING = "/v2/billing",
	KASEYA = "/v2/kaseya",
	BULKIMPORTPAGE = "/v2/imports/:entity"
}

export enum DistributorAvo {
	Ingram = "Ingram",
	TechData = "Techdata",
	DAndH = "D&H",
	Synnex = "Synnex",
	DickerData = "Dickerdata",
	Westcoast = "Westcoast"
}

export const handleConnectedDistributors = (
	userCompany: UserCompany
): string[] => {
	const connectedDistributors: DistributorAvo[] = [];
	!!userCompany.integrations.ingram?.connected_user?.length &&
		connectedDistributors.push(DistributorAvo.Ingram);
	!!userCompany.integrations.tech_data?.connected_user?.length &&
		connectedDistributors.push(DistributorAvo.TechData);
	!!userCompany.integrations.d_and_h?.connected_user?.length &&
		connectedDistributors.push(DistributorAvo.DAndH);
	!!userCompany.integrations.synnex?.connected_user?.length &&
		connectedDistributors.push(DistributorAvo.Synnex);
	!!userCompany.integrations.dicker_data?.connected_user?.length &&
		connectedDistributors.push(DistributorAvo.DickerData);
	!!userCompany.integrations.westcoast?.connected_user?.length &&
		connectedDistributors.push(DistributorAvo.Westcoast);
	return connectedDistributors;
};

export const handleConnectedSalesAndMarketing = (
	userCompany: UserCompany
): string[] => {
	const connectedSalesAndMarketing: string[] = [];
	!!userCompany.integrations.infusion_soft?.connected_user?.length &&
		connectedSalesAndMarketing.push("Infusionsoft");
	!!userCompany.integrations.hubspot?.connected_user?.length &&
		connectedSalesAndMarketing.push("Hubspot");
	return connectedSalesAndMarketing;
};

export const handleConnectedPaymentGateways = (
	userCompany: UserCompany
): string[] => {
	const connectedPaymentGateways: string[] = [];
	!!userCompany.integrations.stripe?.account_id?.length &&
		connectedPaymentGateways.push("Stripe");
	!!userCompany.integrations.connect_booster &&
		connectedPaymentGateways.push("Connect Booster");
	return connectedPaymentGateways;
};

export const handleConnectedAccounting = (
	userCompany: UserCompany
): string[] => {
	const connectedAccounting: string[] = [];
	!!userCompany.integrations.quickbooks?.connected_user?.length &&
		connectedAccounting.push("Quickbooks");
	return connectedAccounting;
};

export enum ZomentumPSAErrorTypes {
	MatchingEntityExistsInIntegration = "matching_entities_exists_in_integration",
	PermissionMissing = "missing_permissions",
	EntityDeletedInIntegration = "entity_deleted_in_integration",
	UnknownErrors = "unknown",
	DependanciesNotFound = "dependencies_not_found",
	InvalidObject = "invalid_object"
}

export interface CreateFreshDeskTicketRequest {
	subject: string;
	description: string;
	product_module?: string;
	ticket_level?: string;
	ticket_type?: string;
	ticket_group_id?: number;
}

export interface AssociatedUser {
	id: string;
	email: string;
	name: Name;
	company_id: string | null;
	vendor_company_id: string | null;
	associated_user_type:
		| "partner_opportunity_owner"
		| "vendor_opportunity_owner"
		| "vendor_opportunity_manager";
}

export interface AssociatedUsersResponse {
	data: AssociatedUser[];
	filtered_count_map: null;
}

export interface CurrencySettings {
	currency: string;
	locale: string;
}

export const vendorOpportunityFieldsCommonWithGrow = [
	"vendor_opportunity_estimated_value",
	"vendor_opportunity_estimated_close_date",
	"vendor_opportunity_primary_client_user_id",
	"vendor_opportunity_linked_client_user_ids"
];

export const vendorClientFieldsCommonWithGrow = [
	"vendor_client_phone",
	"vendor_client_billing_address",
	"vendor_client_fax",
	"vendor_client_website",
	"vendor_client_linked_in_url",
	"vendor_client_facebook_url",
	"vendor_client_twitter_url"
];

export const vendorClientContactFieldsCommonWithGrow = [
	"vendor_client_user_email",
	"vendor_client_user_phone",
	"vendor_client_user_mobile",
	"vendor_client_user_job_title",
	"vendor_client_user_department"
];

export const CurrenciesForCustomSymbol = ["FJD"];

export enum CurrenciesSymbol {
	FJD = "FJ$"
}
